const AjaxClient = require('../clients/AjaxClient')
const CustomElementEventLogger = require('../eventTracking/CustomElementEventLogger')

const appendHistory = s => $('#pwned-passwords-history').val((index, value) => {
    const x = value === "" ? "" : `${value},`
    return `${x}${s}`
})

const logResult = eventData => {
    const logger = new CustomElementEventLogger(new AjaxClient(new XMLHttpRequest()))
    logger.log(eventData)
}

const onPwnedPassword = function (message, passwordTextBox, r, result) {
    message = message.replace("{{count}}", r.count)

    logResult({
        type:'action',
        customElementName: 'REGISTRATION_PWNED_PASSWORD_EVENT',
        customElementValue: 'MEMBER_PASSWORD_IS_PWNED'
    })
    logResult({
        type: 'action',
        customElementName: 'REGISTRATION_PWNED_PASSWORD_PROVIDED',
        customElementValue: r.count
    })

    appendHistory("pwned")

    result.reject(message)
}

const onPwnedPasswordsError = (e, result) => {
    // eslint-disable-next-line no-console
    console.error(e, 'pwned password service error')
    logResult({
        type:'action',
        customElementName: 'REGISTRATION_PWNED_PASSWORD_EVENT',
        customElementValue: 'ERROR_FROM_PWNED_PASSWORD_SERVICE'
    })
    logResult({
        type: 'action',
        customElementName: 'REGISTRATION_PWNED_PASSWORD_ERROR_FROM_SERVICE',
        customElementValue: JSON.stringify(e)
    })
    result.resolve()
}
const onValidatedPassword = (result) => {
    logResult({
        type:'action',
        customElementName: 'REGISTRATION_PWNED_PASSWORD_EVENT',
        customElementValue: 'PASSWORD_WAS_NOT_PWNED'
    })
    appendHistory("safe")
    result.resolve() // passes validation
}

module.exports = {
    init: haveIBeenPwnedAPI => {
        window.Parsley.addValidator('pwnedpassword', {
            priority: 1, // must let all other validators run first
            validateString: function (value, _, parsleyInstance) {
                const result = new $.Deferred()

                const passwordTextBox = $(parsleyInstance.element)


                const message = passwordTextBox[0].getAttribute('data-pwnedpassword-error-template') || ""


                haveIBeenPwnedAPI.check(value)
                    .then(r => {
                        if (r.found) {
                            onPwnedPassword(message, passwordTextBox, r, result)
                        } else {
                            onValidatedPassword(result)
                        }
                    })
                    .catch(e => {
                        // don't fail validation on error O_o
                        onPwnedPasswordsError(e, result)
                    })


                return result
            }
        })
    }
}